module.exports = __webpack_public_path__ + "assets/img/9dec1d376f119b7b3f810a3b2a2482ee.png";